import { render, staticRenderFns } from "./Employee.vue?vue&type=template&id=1dea7852&scoped=true"
import script from "./Employee.vue?vue&type=script&lang=js"
export * from "./Employee.vue?vue&type=script&lang=js"
import style0 from "./Employee.vue?vue&type=style&index=0&id=1dea7852&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dea7852",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jissjohnson/code/Zenrion/CareKraft/zenrion-erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dea7852')) {
      api.createRecord('1dea7852', component.options)
    } else {
      api.reload('1dea7852', component.options)
    }
    module.hot.accept("./Employee.vue?vue&type=template&id=1dea7852&scoped=true", function () {
      api.rerender('1dea7852', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Employee.vue"
export default component.exports